import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <div style={{display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap"}}>
                  <a
                    href="#services"
                    className="btn btn-custom btn-lg page-scroll"
                    style={{"color": "#FFFFFF", "background": "#214150", "border": "2px solid #FFFFFF"}}
                  >
                    🎄 Julefrokost 2026
                  </a>
                  <a
                    href="#sommerfest"
                    className="btn btn-custom btn-lg page-scroll"
                    style={{"color": "#214150", "background": "#F5C518", "border": "2px solid #F5C518", "fontWeight": "bold"}}
                  >
                    ☀️ Sommerfest
                  </a>
                  <a
                    href="#contact"
                    className="btn btn-custom btn-lg page-scroll"
                    onClick={() => { if(window.fbq) window.fbq('track', 'Lead', {content_name: 'Header Book Nu'}); }}
                    style={{"color": "#FFFFFF", "background": "transparent", "border": "2px solid #FFFFFF"}}
                  >
                    Book nu
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
